import { Button } from "@/ds/shadcn/components/ui/button";
import { StatePanel } from "@/ds/custom/StatePanel";
import type { PaginatedInfiniteQueryResult } from "@/lib/common/PaginatedInfiniteQueryResult";
import { CircleOff, SearchIcon } from "lucide-react";
import { useMemo, type PropsWithChildren } from "react";

export interface SearchResultsProps<T> extends PropsWithChildren {
	searchQuery: string;
	forQuery: PaginatedInfiniteQueryResult<T>;
	onCancel?: () => void;
}

export const SearchResults = <T, >(props: SearchResultsProps<T>) => {
	const {
		searchQuery,
		forQuery,
		children,
		onCancel
	} = props;

	const resultsEmpty = useMemo(() => {
		if (!forQuery.data) {
			return false;
		}

		return forQuery.data.pages.flatMap(x => x.results).length === 0;
	}, [forQuery.data]);

	if (!searchQuery && resultsEmpty) {
		return (
			<StatePanel icon={SearchIcon} title="Search" description="Use the search bar above to search for a product.">
				{
					onCancel &&
					<Button variant="outline" onClick={onCancel}>
						Cancel
					</Button>
				}
			</StatePanel>
		);
	}

	if (searchQuery && resultsEmpty) {
		return (
			<StatePanel icon={CircleOff} title="No Results" description="No results were found for the provided search" />
		);
	}

	return (
		<>{children}</>
	);
};
